import React from 'react';
import { st, classes } from './Cell.st.css';

import { AnalyticsLayoutCellProps } from '../AnalyticsLayout.types';

/** Cell */
class Cell extends React.PureComponent<AnalyticsLayoutCellProps> {
  static defaultProps = {
    disableHighlight: false,
    divider: true, // TODO: add default value to showDivider once divider is removed
    children: null,
  };

  static displayName = 'Cell';
  state = { isHovered: false };

  _setHover(isHovered: boolean) {
    this.setState({ isHovered });
  }

  render() {
    const { dataHook, children, disableHighlight, divider } = this.props;
    const { isHovered } = this.state;
    const showDivider = this.props.showDivider ?? divider;

    return (
      <div
        data-hook={dataHook}
        className={st(classes.root, {
          highlight: !disableHighlight && isHovered,
          showDivider,
        })}
        onMouseEnter={() => this._setHover(true)}
        onMouseLeave={() => this._setHover(false)}
      >
        {children}
      </div>
    );
  }
}

export { Cell };
